import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import mapResponsiveProperty from '../utils/mapResponsiveProperty';
import Flex from '../Flex';
import useTheme from '../hooks/useTheme';
var Row = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useTheme = useTheme(),
      _useTheme$grid = _useTheme.grid;

  _useTheme$grid = _useTheme$grid === void 0 ? {} : _useTheme$grid;
  var _useTheme$grid$gutter = _useTheme$grid.gutters,
      gutters = _useTheme$grid$gutter === void 0 ? 2 : _useTheme$grid$gutter;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    mx: mapResponsiveProperty(function (x) {
      return -x;
    }, gutters)
  }, props));
});
Row.displayName = 'Row';
export default Row;